import React from 'react';

/**
 * Tabs — underline-style tab bar.
 *
 * Props:
 *   tabs: Array<{ id: string, label: ReactNode }>
 *   value: active id
 *   onChange:(id) => void
 *   ariaLabel: string
 */
const Tabs = ({ tabs = [], value, onChange, ariaLabel, className = '' }) => (
  <div className={`ps-tabs ${className}`.trim()} role="tablist" aria-label={ariaLabel}>
    {tabs.map((tab) => (
      <button
        key={tab.id}
        type="button"
        role="tab"
        aria-selected={value === tab.id}
        className="ps-tab"
        onClick={() => onChange && onChange(tab.id)}
      >
        {tab.label}
      </button>
    ))}
  </div>
);

export default Tabs;
